import React, { FC } from 'react';
import { StationSummaryCardProps } from './StationSummaryCard.types';
import { AllieCard, AllieEllipse, AllieText } from '../../../components';
import {
  ProductionOrderStatus,
  AllieProductionOrderStatusChip,
} from '../ProductionOrderStatusChip/ProductionOrderStatusChip';
import {
  StationSummaryStyled,
  FlexContainer,
  StyledStationTitleLink,
  StyledStationButton,
} from './StationListSummaryCard.styles';
import { OEEContainer } from './components/OEEContainer';
import { POField } from './components/POField';
import { ProgressContainer } from './components/ProgressContainer';
import { ShiftField } from './components/ShiftField';
import { Stats } from './components/Stats';

const mapProductionStatusBorderColor: Record<string, string> = {
  in_progress: 'none',
  stopped: 'var(--allie-color-error-main)',
  paused: 'none',
  no_productions: 'none',
  technical_stop: 'none',
};

export const AllieStationSummaryCardV2: FC<StationSummaryCardProps> = ({
  title,
  data,
  barData,
  labels,
  onClick,
  className,
  isProductive,
  lastSectionType,
  production,
  OEE,
  statusLabel,
  shiftEndsAt,
  shiftName,
  shiftStartsAt,
  href,
  trackingOnClickEvent,
  isTablet = false,
  isMobile = false,
}) => {
  const isTechnicalStop =
    lastSectionType === 'neutral' && production.status === ProductionOrderStatus.STOPPED;
  return (
    <StationSummaryStyled className={className}>
      <AllieCard
        onClick={() => isMobile && onClick()}
        style={{
          borderRadius: '8px',
          padding: '12px 16px',
          boxSizing: 'border-box',
          // eslint-disable-next-line max-len
          border: `1px solid ${
            production.status === 'stopped'
              ? `${
                  isTechnicalStop
                    ? mapProductionStatusBorderColor[ProductionOrderStatus.TECHNICAL_STOP]
                    : mapProductionStatusBorderColor[production.status]
                }`
              : 'var(--allie-color-neutral-20)'
          }`,
        }}
        content={{
          style: {
            padding: 0,
          },
          children: (
            <FlexContainer gap={24} flexDirection="column">
              <FlexContainer flexDirection="column" gap={11}>
                <FlexContainer
                  gap={13}
                  alignItems={isMobile ? 'flex-start' : 'center'}
                  justifyContent={'space-between'}
                >
                  <StyledStationTitleLink
                    isMobile={isMobile}
                    onClick={() => {
                      trackingOnClickEvent && trackingOnClickEvent('Station Name', title);
                      onClick();
                    }}
                    // href={href}
                  >
                    <span>{title}</span>
                  </StyledStationTitleLink>
                  <AllieProductionOrderStatusChip
                    status={
                      isTechnicalStop ? ProductionOrderStatus.TECHNICAL_STOP : production.status
                    }
                    statusLabel={statusLabel}
                  />
                </FlexContainer>
                <FlexContainer
                  gap={10}
                  justifyContent="space-between"
                  alignItems="center"
                  style={{
                    padding: '6px',
                    background: 'var(--allie-color-neutral-10)',
                    borderRadius: 'var(--allie-radius-xs)',
                  }}
                >
                  <POField label={labels.productionOrder} id={production.legacyId} />
                  <ShiftField shiftName={shiftName} />
                </FlexContainer>
                <FlexContainer gap={32} style={{ padding: '0 4px' }}>
                  <Stats data={data} layout="card" />
                  <OEEContainer value={OEE} isTablet={false} />
                </FlexContainer>

                <ProgressContainer
                  barData={barData}
                  shiftEndsAt={shiftEndsAt}
                  shiftStartsAt={shiftStartsAt}
                  progressBarHeight="27px"
                />
                <StyledStationButton
                  type="button"
                  allieType="secondary"
                  allieColor="neutral"
                  fill="outline"
                  allieSize={isMobile ? 'small' : 'xs'}
                  isMobile={isMobile}
                  full
                  className="see-detail"
                  onClick={() => {
                    onClick();
                    trackingOnClickEvent && trackingOnClickEvent('View more detail button', title);
                  }}
                >
                  <AllieText type={isMobile ? 'button-normal' : 'body3'}>{labels.button}</AllieText>
                </StyledStationButton>
              </FlexContainer>
            </FlexContainer>
          ),
        }}
      />
    </StationSummaryStyled>
  );
};
